import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProprietariosDadosBasicosPage } from './proprietarios-dados-basicos.page';

const routes: Routes = [{ path: '', component: ProprietariosDadosBasicosPage }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProprietariosDadosBasicosRoutingModule { }
